import React, {useState} from 'react';
import { Link } from "react-router-dom";
import { useQuery } from 'react-query';
import NewsLetterPopup from '../NewsletterPopup';
//import Iubenda from 'react-iubenda-policy';
import IubendaCookiePolicy from './IubendaCookiePolicy';
import g_cfg from "../../config";

const FooterBar = props => {
  const { isError, data, error } = useQuery(['menuData'], () => fetchMenuData(), {    
    enabled: !!props.token, // query inattiva finchè il token non è valido (non necessario)
    staleTime: 60 * 60 * 24 * 1000, // cache stale time impostato a 24 ore
  });
  const [NewsLetterOn, setNewsLetterOn] = useState(false);

  // grazie a react-query, dovrebbe prendere i dati dalla cache
  async function fetchMenuData() {
    try {
      var myHeaders = new Headers();
      //console.log("fetchMenuData() - with token: " + Token.access_token);
      myHeaders.append("Authorization", "Bearer " + props.token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/menu/ViewMenu",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          if (props.cfg.debug === true) 
            console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const payload = await response.json();
      if (props.cfg.debug === true)  {
        console.log("fetchMenuData() OK");
        console.log(payload);
      }
      return payload;
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      throw new Error(error.message);
    }
  }

  function closeHandler() {
    setNewsLetterOn(false);
  }

  function socialUrl(url, name, img, cssClass) {
    if (url.length > 0) 
      return (
      <div className={cssClass}>
        <a
          href={url}
          target="blank"
        >
          <img
            src={img}
            alt={name}
            title={name}
          />
        </a>
      </div>
      )
    else
      return null;
  }
    
  if ((!data) || (!data.menu)) {
    //console.log(props);
    if (isError && error !== null) 
      return <p>{error.message}</p>;
    else 
      return null;
  } 

  /*
           <a
              href={g_cfg.iubendaPrivacyUrl}
              className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Privacy Policy "
              target="_blank" rel="noreferrer"
            >
              <p>Privacy Policy</p>
            </a>

            <a 
              href={g_cfg.iubendaCookieUrl} 
              className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " 
              title="Cookie Policy "
              target="_blank" rel="noreferrer"
            >
              <p>Cookie Policy</p>
            </a>
  
            <Iubenda id={g_cfg.IubendaId} type="privacy" styling="white">
              <p>Privacy Policy</p>
            </Iubenda>
            <Iubenda id={g_cfg.IubendaId} type="cookie" styling="nostyle">
              <p>Cookie Policy</p>
            </Iubenda>



Uncaught SyntaxError: expected expression, got '<' iubenda.js'; 

tag.parentNode.insertBefore(s,tag);}; 
if(w.addEventListener){w.addEventListener('load', loader, false);}
else if(w.attachEvent){w.attachEvent('onload', loader);}
else{w.onload = loader;}})(window, document);:1

            <IubendaCookiePolicy cfg={g_cfg} />

  */
              
  //console.log("footer data");
  //console.log(data.menu);
  return (
    <>
      {NewsLetterOn === true ? (
        <NewsLetterPopup
          token={props.token}
          sessionKey={props.sessionKey}
          tokenUpdate={props.tokenUpdate}
          wsCall={props.wsCall}
          closeHandler={closeHandler}
          privacyUrl={props.cfg.iubendaPrivacyUrl}
        />
      ) : null}
      <footer>
        <div className="contenitore_footer">
          <div key="cf1" className="colonna_footer">
            <div className="logo_footer">
              <Link to="/home">
                <img
                  src="/images/logo_footer_on.png"
                  alt="BBurago"
                  title="BBurago"
                />
              </Link>
            </div>
            <p>&nbsp;</p>
          </div>
          <div key="cf2" className="colonna_footer">
            <h3>{g_cfg.name}</h3>
            <p>{g_cfg.address}</p>
            <p>{g_cfg.city}</p>
            <p>{g_cfg.country}</p>
            <p>Tel. {g_cfg.phone}</p>
            <Link key="h" to="/">
              <p>{g_cfg.siteName}</p>
            </Link>
            <a href={"mailto:" + g_cfg.siteEmail}>
              <p>{g_cfg.siteEmail}</p>
            </a>
          </div>
          <div key="cf3" className="colonna_footer">
            {data.menu.map((val, i) => {
              if (val.type === "Category") {
                return (
                  <React.Fragment key={"df" + i}>
                    {val.SubCategory.map((el) => {
                      return (
                        <Link
                          key={"fcs_" + el.id}
                          to={
                            "/" +
                            g_cfg.catalogSlug +
                            "/" +
                            el.slug +
                            "/" +
                            el.id
                          }
                        >
                          <p>{el.nome}</p>
                        </Link>
                      );
                    })}
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </div>
          <div key="cf4" className="colonna_footer">
            <Link key="cn" to="/contatti">
              <p>Contatti</p>
            </Link>
            <Link key="cv" to="/condizioni-vendita">
              <p>Condizioni di vendita</p>
            </Link>


            <a
              href={g_cfg.iubendaPrivacyUrl}
              className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Privacy Policy "
              target="_blank" rel="noreferrer"
            >
              <p>Privacy Policy</p>
            </a>

            <a 
              href={g_cfg.iubendaCookieUrl} 
              className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe " 
              title="Cookie Policy "
              target="_blank" rel="noreferrer"
            >
              <p>Cookie Policy</p>
            </a>


            <Link key="pr" to="/profilo">
              <p>Accedi</p>
            </Link>
          </div>
          <div key="cf5" className="colonna_footer">
            <a href={g_cfg.facebookUrl} target="_blank" rel="noreferrer">
              <p>Facebook</p>
            </a>
            <a href={g_cfg.instagramUrl} target="_blank" rel="noreferrer">
              <p>Instagram</p>
            </a>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <img
              src="/images/pagamenti_footer.svg"
              alt="Carte di credito"
              title="Carte di credito"
            />
          </div>
          <div key="cf6" className="colonna_footer">
            <div className="social_footer">
              {socialUrl(
                g_cfg.facebookUrl,
                "Facebook",
                "/images/facebook_footer_on.svg",
                "facebook_footer"
              )}
              {socialUrl(
                g_cfg.instagramUrl,
                "Instagram",
                "/images/instagram_footer_on.svg",
                "instagram_footer"
              )}
              {socialUrl(
                g_cfg.pinterestUrl,
                "Pinterest",
                "/images/pinterest_footer_on.svg",
                "pinterest_footer"
              )}
              {socialUrl(
                g_cfg.twitterUrl,
                "Twitter",
                "/images/twitter_footer_on.svg",
                "twitter_footer"
              )}
              {socialUrl(
                g_cfg.youTubeUrl,
                "YouTube",
                "/images/youtube_footer_on.svg",
                "youtube_footer"
              )}
            </div>
            <div
              className="newsletter_footer"
              onClick={() => setNewsLetterOn(true)}
            >
              <img
                src="/images/newsletter_footer_on.svg"
                alt="Newsletter Bburago"
                title="Newsletter Bburago"
              />
            </div>
            <div className="nottolino_footer">
              <a
                href="https://www.montefiorino.com"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/images/nottolino_on.svg"
                  alt="Studio Montefiorino"
                  title="Studio Montefiorino"
                />
              </a>
              &nbsp;
            </div>
            <div className="clear"></div>
          </div>
        </div>
        <div className="avviso_footer_01">
          <p>{data.footer_text.avvisoLegale}</p>
        </div>
        <div className="avviso_footer_02">
          <p>
            © {new Date().getFullYear()} www.bburago-shop.it di Mediatoys srl -
            Via Marsala, 15 - 40126 Bologna - Italia - Tel. +39 051 231937 P.Iva
            IT03189691201 - Reg.Imp. BO03189691201 - R.E.A. 499095 - Cap. Soc.
            20.000,00 euro i.v.{" "}
          </p>
        </div>
      </footer>
    </>
  );
}

export default FooterBar;